<template>
  <div class="airwallex-card">
    <div id="airwallex-card" ref="card"/>
    <p id="airwallex-error" ref="error"/>
  </div>
</template>

<script>
import { loadAirwallex } from 'airwallex-payment-elements'

export default {
  name: 'gh-airwallex-card',
  props: {
    styleOptions: {
      default: () => {
        return {
          fontSize: '14px',
        }
      },
    },
  },
  data() {
    return {
      airwallex: undefined,
      card: undefined,
      error: '',
      isDirty: false,
    }
  },

  computed: {
    isValid() {
      return this.isDirty && !this.error
    },
  },

  methods: {
    init() {
      loadAirwallex({
        env: LaraVue.airwallex.env,
        origin: window.location.origin,
      }).then((airwallex) => {
        this.airwallex = airwallex
        this.card = this.airwallex.createElement('card', {
          style: {
            base: this.styleOptions,
          }
        })
        this.card.mount('airwallex-card')
      })
    },

    onBlur(event) {
      const {error, complete} = event.detail

      if (error) {
        this.error = error.message || JSON.stringify(error)

        return
      }

      if (complete) {
        this.error = ''
        this.isDirty = true
      }
    },

    onError(event) {
      const {error} = event.detail

      this.error = error.message
    },

    onFocus() {
      this.error = ''
      this.isDirty = false
    },

    checkCard() {
      if (!this.isDirty) {
        this.error = 'Please input your payment details'

        return false
      }

      return this.isValid
    },

    async confirmPaymentIntent({paymentIntentId, clientSecret}) {
      const response = await this.airwallex.confirmPaymentIntent({
        element: this.card,
        intent_id: paymentIntentId,
        client_secret: clientSecret,
      })

      return response.id
    },

    async createPaymentConsent({
                                 customerId,
                                 clientSecret,
                                 currency = null,
                                 paymentIntentId = null,
                                 cardName = null,
                               }) {
      const payload = {
        element: this.card,
        client_secret: clientSecret,
        customer_id: customerId,
        next_triggered_by: 'merchant',
        cardname: cardName,
      }

      if (paymentIntentId) {
        payload.intent_id = paymentIntentId
      }

      if (currency) {
        payload.currency = currency
      }

      const response = await this.airwallex.createPaymentConsent(payload)

      return response.payment_consent_id
    },
  },

  watch: {
    error(value) {
      if (value) {
        this.$refs.error.style.display = 'block'
        this.$refs.error.innerHTML = value
      } else {
        this.$refs.error.style.display = 'none'
      }
    },
  },

  mounted() {
    this.init()
    this.$refs.card.addEventListener('onError', this.onError)
    this.$refs.card.addEventListener('onBlur', this.onBlur)
    this.$refs.card.addEventListener('onFocus', this.onFocus)
  },

  beforeDestroy() {
    this.$refs.card.removeEventListener('onError', this.onError)
    this.$refs.card.removeEventListener('onBlur', this.onBlur)
    this.$refs.card.removeEventListener('onFocus', this.onFocus)
  },
}
</script>

<style lang="scss" scoped>
.airwallex-card {
  position: relative;
}

#airwallex-card {
  display: flex;
  align-items: center;
  height: 42px;
  padding: 0.75rem;
  border: 1px solid #dcdfe6;
  background: inherit;
}

#airwallex-error {
  color: #f56c6c;
  font-size: 14px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 100%;
  left: 0;
}
</style>
